import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-employer-summary',
  templateUrl: './dashboard-summary.component.html',
  styleUrls: ['./dashboard-summary.component.scss']
})
export class DashboardEmployerSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
